module.exports = __webpack_public_path__ + "static/App-brief-2ff450ec45bf851d6c01a7f56fac63bb.pdf";